/** 上传视频允许的扩展名（小写，含点） */
export const VIDEO_UPLOAD_ALLOWED_EXTENSIONS = [
  ".mp4",
  ".avi",
  ".mov",
  ".mkv",
  ".wmv",
  ".flv",
  ".webm",
  ".m4v",
] as const;

/** 主文件名（不含扩展名）：中文、英文、数字、_ - () */
const VIDEO_BASE_NAME_PATTERN = /^[\u4e00-\u9fffA-Za-z0-9_\-()]+$/;

export function getVideoUploadBaseName(fileName: string): string {
  return fileName.replace(/\.[^/.]+$/, "");
}

export function getVideoUploadFileNameInvalidMessage(label: string): string {
  const name = String(label || "").trim();
  return name ? `${name}此视频名称含特殊字符，上传失败` : "此视频名称含特殊字符，上传失败";
}

export function validateVideoUploadFileName(fileName: string): {
  valid: boolean;
  message?: string;
} {
  const trimmed = String(fileName || "").trim();
  if (!trimmed) {
    return { valid: false, message: getVideoUploadFileNameInvalidMessage("") };
  }

  const lastDot = trimmed.lastIndexOf(".");
  if (lastDot <= 0 || lastDot === trimmed.length - 1) {
    const label = getVideoUploadBaseName(trimmed) || trimmed;
    return { valid: false, message: getVideoUploadFileNameInvalidMessage(label) };
  }

  const baseName = trimmed.slice(0, lastDot);
  const ext = trimmed.slice(lastDot).toLowerCase();

  if (!baseName || !VIDEO_BASE_NAME_PATTERN.test(baseName)) {
    return { valid: false, message: getVideoUploadFileNameInvalidMessage(baseName || trimmed) };
  }

  if (!VIDEO_UPLOAD_ALLOWED_EXTENSIONS.includes(ext as (typeof VIDEO_UPLOAD_ALLOWED_EXTENSIONS)[number])) {
    return { valid: false, message: getVideoUploadFileNameInvalidMessage(baseName) };
  }

  return { valid: true };
}
